import { render } from "./declarationForm.vue?vue&type=template&id=1b009ccc&scoped=true"
import script from "./declarationForm.vue?vue&type=script&lang=js"
export * from "./declarationForm.vue?vue&type=script&lang=js"

import "./declarationForm.vue?vue&type=style&index=0&id=1b009ccc&scoped=true&lang=css"

import exportComponent from "D:\\Developpement\\HATPLC\\frontend 25122025\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b009ccc"]])

export default __exports__